import { useEffect, useRef, useState } from "react";
import { useQuery } from "react-query";
import Select from "react-select";
import { getZones } from "../../../MyApi/zones";
import TrackingMapGoogle from "../../map/trackingGooleMap";
import { getCountries } from "../../../MyApi/admin/countries/countries";
import i18next from "i18next";
import SkeletonWrapper from "../../UI/skeletonWrapper";
import { getGovernorates } from "../../../MyApi/admin/governorates";
import { getCities } from "../../../MyApi/admin/cities";
const AddressInfoForm = ({
  setAddress,
  address,
  errorMessage,
  setErrorMessage,
  setLocationError,
  locationError,
  storeData,
  mode,
  setFormData,
  isLoading,
}) => {
  const [locations, setLoactions] = useState(null);
  const [area, setArea] = useState([]);
  const prevZoneRef = useRef(null);
  console.log("locations", locations);
  const lang = i18next.language;

  useEffect(() => {
    if (locations) {
      setAddress((prev) => ({
        ...prev,
        latitude: locations.lat,
        longitude: locations.long,
      }));
      setLocationError((prev) => ({
        ...prev,
        location: "",
      }));
    }
  }, [locations]);
  useEffect(() => {
    if (!prevZoneRef.current) {
      // first mount (edit load)
      prevZoneRef.current = address.zone_id;
      return;
    }

    if (prevZoneRef.current !== address.zone_id) {
      // real change by user
      setLoactions(null);
    }

    prevZoneRef.current = address.zone_id;
  }, [address.zone_id]);
  useEffect(() => {
    if (mode === "edit") {
      if (Object.values(storeData).length > 0) {
        setLoactions((prev) => ({
          ...prev,
          lat: storeData.address_data.latitude,
          long: storeData.address_data.longitude,
        }));
      }
    }
  }, [storeData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("first", e.target.options[e.target.options.selectedIndex].id);
    setAddress((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrorMessage((prev) => ({ ...prev, [name]: null }));
  };
  const handleChangeMultiZones = (option) => {
    console.log("option", option);

    let zonesToCover = [];
    option.forEach((zone) => {
      zonesToCover.push(zone.id);
    });
    console.log("zonesToCover", zonesToCover);
    setAddress((prev) => ({
      ...prev,
      zones_to_cover: zonesToCover,
    }));
  };
  const countryQuery = useQuery("getCountries", () => getCountries());
  const governoateQuery = useQuery(
    ["getGovernorate", address.country_id],
    () => getGovernorates(address.country_id),
    {
      enabled: !!address.country_id,
    },
  );
  const citiesQuery = useQuery(
    ["getCities", address.governorate_id],
    () => getCities("", "", address.governorate_id),
    {
      enabled: !!address.governorate_id,
    },
  );

  const zonesQuery = useQuery(
    ["getZones", address.city_id],
    () => getZones(lang, address.city_id),
    {
      enabled: !!address.city_id,
    },
  );
  const zones = zonesQuery.data?.data?.zones || [];
  const countries = countryQuery?.data?.data?.countries || [];
  const cities = citiesQuery?.data?.data?.cities || [];
  const governorates = governoateQuery?.data?.data?.governorates || [];
  useEffect(() => {
    const selectedZone =
      zones.find((zone) => zone.id === +address.zone_id) || [];
    console.log("selectedZone in else", selectedZone);
    setArea(selectedZone.area);
    //     if(storeData?.address_data?.zone){
    //           const selectedZone =zones.find((zone)=>(zone.id === storeData?.address_data?.zone?.id))  ||[]
    //           console.log('selectedZone', selectedZone)
    //  setArea(selectedZone.area)
    //     }else{

    //     }
  }, [address.zone_id, storeData, zones]);

  const handleChangeCountryId = (selectedOption) => {
    setAddress((prev) => ({ ...prev, country_id: selectedOption?.id }));

    setFormData((prev) => ({
      ...prev,
      service_fee_percentage: selectedOption?.service_fee,
      tax_rate: selectedOption?.tax,
    }));
  };

  const handleChangeGovernorateId = (selectedOption) => {
    setAddress((prev) => ({
      ...prev,
      governorate_id: selectedOption?.id,
    }));
  };

  const handleChangeCityId = (selectedOption) => {
    setAddress((prev) => ({
      ...prev,
      city_id: selectedOption?.id,
    }));
  };

  return (
    <div className="row add">
      <div className="col-md-4 mb-3">
        <label htmlFor="country" className="form-label">
          الدولة
        </label>
        <Select
          placeholder="اختر الدولة"
          options={countries}
          getOptionLabel={(e) => e.name}
          getOptionValue={(e) => e.id}
          value={countries.find((c) => c.id === address.country_id) || null}
          onChange={handleChangeCountryId}
          isClearable
        />
      </div>
      <div className="col-md-4 mb-3">
        <label htmlFor="country" className="form-label">
          المحافظة
        </label>
        <Select
          placeholder={
            address.country_id
              ? governoateQuery.isLoading
                ? "جاري تحميل المحافظات..."
                : "اختر المحافظة"
              : "اختر الدولة أولاً"
          }
          options={governorates}
          getOptionLabel={(e) => e.name}
          getOptionValue={(e) => e.id}
          value={
            governorates.find((g) => g.id === address.governorate_id) || null
          }
          onChange={handleChangeGovernorateId}
          isClearable
          isLoading={governoateQuery.isLoading}
          isDisabled={!address.country_id}
        />
      </div>

      <div className="col-md-4 mb-3">
        <label htmlFor="country" className="form-label">
          المدينة
        </label>
        <Select
          placeholder={
            address.governorate_id
              ? citiesQuery.isLoading
                ? "جاري تحميل المدن..."
                : "اختر المدينة"
              : "اختر المحافظة أولاً"
          }
          options={cities}
          getOptionLabel={(e) => e.name}
          getOptionValue={(e) => e.id}
          value={cities.find((c) => c.id === address.city_id) || null}
          onChange={handleChangeCityId}
          isClearable
          isLoading={citiesQuery.isLoading}
          isDisabled={!address.governorate_id}
        />
      </div>
      <div className="col-md-6 mb-3">
        <label className="form-label">المنطقة </label>
        <SkeletonWrapper isLoading={isLoading}>
          <select
            name="zone_id"
            value={address.zone_id}
            id={address.area}
            onChange={handleChange}
            className="form-select"
            required
            disabled={!address.city_id}
          >
            <option value="">
              {address.city_id
                ? zonesQuery.isLoading
                  ? "جاري تحميل المناطق..."
                  : "اختر المنطقة"
                : "اختر المدينة أولاً"}
            </option>
            {zones.map((zone) => (
              <option key={zone.id} value={zone.id} id={zone.area}>
                {zone.name}
              </option>
            ))}
          </select>
        </SkeletonWrapper>
      </div>
      <div className="col-md-6 mb-3">
        <label className="form-label">المنطقة المغطاة</label>
        <Select
          isMulti
          name="zones_to_cover"
          value={zones.filter((zone) =>
            address.zones_to_cover.includes(zone.id),
          )}
          options={zones}
          getOptionLabel={(e) => e.name}
          getOptionValue={(e) => e.id}
          onChange={handleChangeMultiZones}
          placeholder={
            address.city_id
              ? zonesQuery.isLoading
                ? "جاري تحميل المناطق..."
                : "اختار المنطقة المغطاة"
              : "اختر المدينة أولاً"
          }
          isDisabled={!address.city_id}
          isLoading={zonesQuery.isLoading}
        />
      </div>
      <div className="col-md-12">
        <div className={`form-group ${locationError ? "is-invalid" : ""}`}>
          <h6 className="form-label">اختر الموقع</h6>
          <TrackingMapGoogle
            locations={locations}
            setLocations={setLoactions}
            area={area}
          />
          <input
            type="hidden"
            required
            className="form-control d-none"
            value={address.latitude}
          />
          {locationError?.location && (
            <div className="text-danger mt-1">{locationError.location}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddressInfoForm;
